import { handleActions } from 'redux-actions';
import { Actions, setOrgsBusy, setOrgs, setOrgsError, updateOrg } from 'actions/orgActions';
import { OrgId, OrgWithStats } from 'shared/models';

export type State = Readonly<{
    data: Record<OrgId, OrgWithStats>;
    busy: boolean;
    error: Error | null;
}>;

export const initialState = Object.freeze<State>({
    data: {},
    busy: false,
    error: null,
});

export const orgsReducer = handleActions({
    [Actions.SET_ORGS_BUSY]: (state: State, action: ReturnType<typeof setOrgsBusy>) => {
        return {
            ...state,
            busy: action.payload,
        };
    },
    [Actions.SET_ORGS]: (state: State, action: ReturnType<typeof setOrgs>) => {
        return {
            ...state,
            data: action.payload,
        };
    },
    [Actions.SET_ORGS_ERROR]: (state: State, action: ReturnType<typeof setOrgsError>) => {
        return {
            ...state,
            error: action.payload,
        };
    },

    [Actions.UPDATE_ORG]: (state: State, action: ReturnType<typeof updateOrg>) => {
        const org = action.payload;
        const { data } = state;
        return {
            ...state,
            data: {
                ...data,
                [org.id]: org,
            },
        };
    },
} as any, initialState);
